import { dateFormat, userFullName } from "helpers/common";
import { useCallback, useMemo, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import downArrow from "Assets/images/downArro.png";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import AddNotesModal from "components/Modals/AddNotesModal";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CREATE_NOTES, EDIT_NOTES } from "config/paths";
import { CommonSelect, CstmPagination } from "components/Common/Common";
import { useDeleteNoteMutation, useGetNoteOwnersFilterListQuery, useGetNotesListQuery } from "store/services/V2/notes";
import confirmDialogV2 from "utils/confirmationDialogV2";
import userImg from 'Assets/images/user.png';
import AddNotesCollaboratorsModal from "components/Modals/AddNotesCollaborators";
import TableLayoutV2 from "components/TableLayoutV2";
import ErrorComponent from "components/shared/ErrorComponent";
import { useDispatch, useSelector } from "react-redux";
import { initialFilterState, notesFilter } from "store/slices/filter";
import { debounce } from "lodash";


const singleNote = { note: "", disable: false };

const NotesTable = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { clientId, moduleName, clientType } = useParams()
    const pageSize = 10
    const [currentPage, setCurrentPage] = useState(1)
    const [showModal, setShowModal] = useState(false)
    const filter = useSelector(state => state?.filter?.notesFilter);
    const profile = useSelector((state) => state?.auth?.user)

    const breadcrumbItems = [
        { label: "Notes" },
    ];


    const [notesModal, setNotesModal] = useState(false)
    const [currentEntry, setCurrentEntry] = useState(null)

    const { data: notes, isLoading, isFetching, isError } = useGetNotesListQuery({ limit: pageSize, page: currentPage, ...filter });
    const totalRecords = notes?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [deleteNote, { isLoading: deleteNoteLoading }] = useDeleteNoteMutation()
    const { data: ownerFilterData, isFetching: ownersFilterFetching } = useGetNoteOwnersFilterListQuery();

    const ownersList = useMemo(() => {
        if (!ownerFilterData?.length) return [];

        return ownerFilterData.map(item => ({ label: userFullName(item?.noteOwner), value: item?.noteOwner?.id }));
    }, [ownerFilterData, profile?.id]);

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleDelete = async (e, id) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "DELETE NOTE",
            message: "Are you sure you want to delete this note?",
        });
        if (!isConfirm) {
            return;
        }

        try {
            await deleteNote({ id }).unwrap()
        } catch (error) {
            console.log('error', error)
        }
    }

    const column = [
        {
            head: "TITLE",
            accessor: "title",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold">{item?.title}</h6>
            ),
        },
        {
            head: "OWNER",
            accessor: "owner",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <div className="d-flex gap-10 align-items-center">
                    <img
                        src={item?.noteOwner?.therapist_detail?.profile_picture || userImg}
                        alt="profile"
                        style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            objectFit: "cover",
                        }}
                    /> {userFullName(item?.noteOwner)}
                </div>
            ),
        },
        {
            head: "COLLABORATORS",
            accessor: "collaborators",
            isComponent: true,
            component: (item, ind) => (
                <div className="d-flex gap-10 align-items-center">
                    {item?.therapists?.length > 0 ? item?.therapists?.map((collaborator) => (
                        <img
                            src={collaborator?.therapist?.therapist_detail?.profile_picture || userImg}
                            alt="profile"
                            style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                objectFit: "cover",
                            }}
                        />)) : <span>This note has no collaborators.</span>}
                </div>
            ),
        },
        {
            head: "DATE CREATED",
            accessor: "createdAt",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <div>
                    {item?.date ? dateFormat(item?.date, "MMM D, YYYY") : "--"}
                </div>
            ),
        },
        {
            head: "",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    <Dropdown
                        onClick={(e) => e.stopPropagation()}
                    // show={index == dropdownIndex}
                    // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
                    >
                        <Dropdown.Toggle
                            variant="transparent"
                            className="p-0 border-0 text-dark w-100"
                            id="dropdown-basic"
                        >
                            <span className="icn ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="13"
                                    viewBox="0 0 28 13"
                                    fill="none"
                                >
                                    <rect width="28" height="13" rx="6.5" fill="" />
                                    <path
                                        d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                                        fill="#315D99"
                                    />
                                    <path
                                        d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                                        fill="#315D99"
                                    />
                                    <path
                                        d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                                        fill="#315D99"
                                    />
                                </svg>
                            </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                            <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                                {/* <h5 className="cursor-pointer proxima mb-2" onClick={(e) => { setCurrentEntry(item); setShowModal(true); }} style={{ borderBottom: "0.5px solid #000", padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Add Collaborators</h5> */}
                                <h5 className="cursor-pointer proxima mb-2" onClick={(e) => { navigate(generatePath(EDIT_NOTES, { id: item?.id })) }} style={{ padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>{item?.noteOwner?.id == profile?.id ? "Edit" : "View"}</h5>
                                {
                                    item?.noteOwner?.id == profile?.id &&
                                    <h5 className="cursor-pointer proxima mb-2" onClick={(e) => { handleDelete(e, item?.id) }} style={{ padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Delete</h5>
                                }

                            </ul>
                        </Dropdown.Menu>
                    </Dropdown>

                    {
                        item?.status == "complete" && <div
                            className="cursor-pointer d-flex align-items-center"
                            style={{ padding: "10px 10px" }}
                            onClick={(e) => {
                                e.stopPropagation(); // prevent row navigation
                                toggleRow(item.id);
                            }}
                        >
                            {openRow === item.id ? (
                                <img width={12} src={downArrow} alt="Collapse" />
                            ) : (
                                <img width={7} src={rightArrow} alt="Expand" />
                            )}
                        </div>
                    }
                </div>
            ),
        },
    ];

    const handleFilterChange = (key) => (value) => {
        dispatch(notesFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const resetFilter = () => {
        dispatch(notesFilter(initialFilterState.notesFilter));
        setCurrentPage(1)
    };

    const handleSearchChange = useCallback(debounce((value) => {
        setCurrentPage(1);
        handleFilterChange("search")(value);
    }, 500), [handleFilterChange, 500]);

    return (
        <>
            <AddNotesModal currentEntry={currentEntry} setCurrentEntry={setCurrentEntry} show={notesModal} setShow={setNotesModal} />
            <AddNotesCollaboratorsModal
                show={showModal}
                setShow={setShowModal}
                therapists={currentEntry?.therapists}
                noteTableId={currentEntry?.id}
            // therapists={values?.therapistData || []}
            // type="delete"
            // confirmHandler={handleDelete}
            />

            {
                isLoading ? <LoadingIndicator /> : <div className="">
                    {(isFetching || deleteNoteLoading) && <LoadingOverlay />}
                    <section
                        className={`position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row className="pt-3">
                                <Col lg="6">
                                    {/* <Breadcrumbs items={breadcrumbItems} /> */}
                                </Col>
                            </Row>
                            <div style={{ padding: "12px", borderRadius: "4px" }}>

                                <Row className="" >
                                    <Col lg='10'>
                                        <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                            NOTES
                                        </p>
                                    </Col>
                                    <Col lg='2'>
                                        <button
                                            onClick={() => { navigate(CREATE_NOTES) }}
                                            type="button"
                                            className="d-flex w-100 align-items-center gap-2 justify-content-center discharge-screen"
                                        // disabled={isFetching || submitting || copyReportLoading}
                                        // isLoading={submitReportLoading || submitting}
                                        >
                                            Add New +
                                        </button>
                                    </Col>
                                </Row>
                                <Row className="reports-v2">
                                    <Col lg="4">
                                        <div className="w-100 align-items-center gap-3">
                                            <label className="discharge-screen-label mb-0">Search</label>
                                            <input
                                                onChange={(e) => handleSearchChange(e.target.value)}
                                                // style={{outline: "blue"}}
                                                className={`input-new readonly-box h-auto search-input-filter-v2`}
                                                placeholder="Find notes..."
                                                defaultValue={filter?.search}
                                                type="search"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg="3">
                                        <div className="w-100 align-items-center gap-3">
                                            <label className="discharge-screen-label mb-0">Date</label>
                                            <input
                                                onChange={(e) => {
                                                    console.log("on change", e.target.value);
                                                    handleFilterChange("date")(e.target.value)
                                                }}
                                                // style={{outline: "blue"}}
                                                className={`input-new readonly-box h-auto search-input-filter-v2`}
                                                placeholder="Find notes..."
                                                defaultValue={filter?.date}
                                                type="date"
                                            />
                                        </div>
                                    </Col>
                                    <Col md='3'>
                                        <div className="w-100 align-items-center gap-3">
                                            <label className="discharge-screen-label mb-0">Owner</label>
                                            <CommonSelect
                                                placeholder={"Choose one..."}
                                                option={ownersList}
                                                onChange={(e) => handleFilterChange("owner")(e)}
                                                value={filter?.owner}
                                                // onInputChange={(val) => handleSearch(val)}
                                                isFilterV2
                                                isClearable
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%",
                                                    }),
                                                }}
                                                isLoading={ownersFilterFetching}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                {/* {
                                    notes?.records?.length > 0 ? <div className="mt-2">

                                        <table className="w-100 mb-5">
                                            <thead>
                                                <tr>
                                                    <th className="fw-medium" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        NAME
                                                        <img width={9} height={6} className="ms-2" src={downArrow} alt="downArrow" />
                                                    </th>
                                                    <th className="fw-medium" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        OWNER
                                                        <img width={9} height={6} className="ms-2" src={downArrow} alt="downArrow" />
                                                    </th>
                                                    <th className="fw-medium" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        COLLABORATORS
                                                        <img width={9} height={6} className="ms-2" src={downArrow} alt="downArrow" />
                                                    </th>
                                                    <th className="fw-medium text-end" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        DATE CREATED
                                                        <img width={9} height={6} className="ms-2" src={downArrow} alt="downArrow" />
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }} ></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {notes?.records?.map((item) => {
                                                    return (
                                                        <tr className="cursor-pointer" onClick={() => { navigate(generatePath(EDIT_NOTES, { clientId, clientType, moduleName, noteId: item?.id })) }}>
                                                            <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>{item?.title}</td>
                                                            <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F", }}>
                                                                <div className="d-flex gap-10 align-items-center">
                                                                    <img
                                                                        src={item?.noteOwner?.therapist_detail?.profile_picture || userImg}
                                                                        alt="profile"
                                                                        style={{
                                                                            width: "32px",
                                                                            height: "32px",
                                                                            borderRadius: "50%",
                                                                            objectFit: "cover",
                                                                        }}
                                                                    /> {userFullName(item?.noteOwner)}
                                                                </div>
                                                            </td>
                                                            <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F", }}>
                                                                <div className="d-flex gap-10 align-items-center">
                                                                    {item?.therapists?.length > 0 ? item?.therapists?.map((collaborator) => (
                                                                        <img
                                                                            src={collaborator?.therapist?.therapist_detail?.profile_picture || userImg}
                                                                            alt="profile"
                                                                            style={{
                                                                                width: "32px",
                                                                                height: "32px",
                                                                                borderRadius: "50%",
                                                                                objectFit: "cover",
                                                                            }}
                                                                        />)) : <span>This note has no collaborators.</span>}
                                                                </div>
                                                            </td>
                                                            <td className="text-end" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                {dateFormat(item?.createdAt, "MMM D, YYYY")}
                                                            </td>
                                                            <td className="text-end" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                <div className="ActnBtn d-flex align-items-center  gap-10">
                                                                    <Dropdown
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <Dropdown.Toggle
                                                                            variant="transparent"
                                                                            className="p-0 border-0 text-dark w-100"
                                                                            id="dropdown-basic"
                                                                        >
                                                                            <span className="icn ">
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="28"
                                                                                    height="13"
                                                                                    viewBox="0 0 28 13"
                                                                                    fill="none"
                                                                                >
                                                                                    <rect width="28" height="13" rx="6.5" fill="" />
                                                                                    <path
                                                                                        d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                                                                                        fill="#315D99"
                                                                                    />
                                                                                    <path
                                                                                        d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                                                                                        fill="#315D99"
                                                                                    />
                                                                                    <path
                                                                                        d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                                                                                        fill="#315D99"
                                                                                    />
                                                                                </svg>
                                                                            </span>
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                                                                            <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                                                                                <h5 className="cursor-pointer proxima mb-2" onClick={(e) => { handleDelete(e, item?.id) }} style={{ padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Delete</h5>
                                                                            </ul>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>

                                                                    {
                                                                        item?.status == "complete" && <div
                                                                            className="cursor-pointer d-flex align-items-center"
                                                                            style={{ padding: "10px 10px" }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation(); // prevent row navigation
                                                                                toggleRow(item.id);
                                                                            }}
                                                                        >
                                                                            {openRow === item.id ? (
                                                                                <img width={12} src={downArrow} alt="Collapse" />
                                                                            ) : (
                                                                                <img width={7} src={rightArrow} alt="Expand" />
                                                                            )}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                            </tbody>
                                        </table>

                                        <CstmPagination
                                            totalPages={totalPages}
                                            activePage={currentPage}
                                            className="paginationV2"
                                            handlePageChange={handlePageChange}
                                        />
                                    </div> : <NoRecordFoundV2 message="Looks like you haven’t created any notes yet." />
                                } */}
                                <Col lg="12" className="">
                                    <div className="table-outer">
                                        {isError ? (
                                            <ErrorComponent />
                                        ) : (
                                            <>
                                                {(isFetching) && <LoadingOverlay />}
                                                {/* <TableLayout
                                                      data={schoolClients}
                                                      column={column}
                                                      url={SCHOOL_CLIENT_DETAIL.replace("/:id", "")}
                                                    // url={"/manage-team/therapist-profiles/detail/"}
                                                    /> */}
                                                <TableLayoutV2
                                                    data={notes?.records || []}
                                                    column={column}
                                                    // filter={filter}
                                                    url={EDIT_NOTES.replace("/:id", "")}
                                                // handleSort={handleFilterChange("sort")}
                                                />
                                            </>
                                        )}
                                        <CstmPagination
                                            totalPages={totalPages}
                                            className={'paginationV2'}
                                            activePage={currentPage}
                                            handlePageChange={handlePageChange}
                                        />
                                    </div>
                                </Col>
                            </div>
                        </Container>
                    </section>
                </div>
            }
        </>
    );

};

export default NotesTable;